// @ts-nocheck
/**
 * 対戦結果・報酬モーダル
 */

import React from 'react';
import type { BattleRewardResult, NpcId } from '../data/types';
import { formatRewardText } from '../systems/rewardCalculator';
import { getNpcConfig } from '../data/constants';
import { resultModalStyles as styles, modalStyles } from '../styles/adventureStyles';
import { COMPETITORS } from '../../collection/tournament/data/competitors';

interface BattleResultModalProps {
  isOpen: boolean;
  isWin: boolean;
  npcId: NpcId | null;
  reward: BattleRewardResult | null;
  onClose: () => void;
  onRematch?: () => void;
  onOpenPacks?: () => void;
}

export const BattleResultModal: React.FC<BattleResultModalProps> = ({
  isOpen,
  isWin,
  npcId,
  reward,
  onClose,
  onRematch,
  onOpenPacks,
}) => {
  if (!isOpen || !npcId) return null;

  const competitor = COMPETITORS[npcId];
  const npcName = competitor?.name || npcId;
  const portrait = competitor?.portrait || '❓';
  const quotes = competitor?.quotes;

  // 勝敗に応じた台詞
  const quote = isWin ? quotes?.lose : quotes?.win;

  // 報酬テキスト
  const rewardLines = reward ? formatRewardText(reward) : [];
  const hasReward = rewardLines.length > 0;
  const hasPacks = reward && reward.packs.length > 0;

  // 新規アンロックの名前取得
  const newUnlockNames = reward?.newUnlocks.map((id) => {
    const c = COMPETITORS[id];
    return c?.name || id;
  }) || [];

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
        {/* 結果タイトル */}
        <div
          style={{
            ...styles.resultTitle,
            ...(isWin ? styles.resultWin : styles.resultLose),
          }}
        >
          {isWin ? '🎉 勝利！ 🎉' : '😢 敗北...'}
        </div>

        <div style={modalStyles.body}>
          {/* NPC情報 */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <div style={{ fontSize: '48px', marginBottom: '8px' }}>{portrait}</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{npcName}</div>
          </div>

          {/* 台詞 */}
          <div style={modalStyles.quote}>
            「{quote || '...'}」
          </div>

          {/* 報酬セクション（勝利時のみ） */}
          {isWin && hasReward && (
            <div style={styles.rewardSection}>
              <div style={styles.rewardTitle}>
                {reward?.isFirstClear ? '🏆 初回クリア報酬！' : '💎 報酬獲得！'}
              </div>
              <ul style={modalStyles.rewardList}>
                {rewardLines.map((line, i) => (
                  <li key={i} style={modalStyles.rewardItem}>{line}</li>
                ))}
              </ul>
            </div>
          )}

          {/* 新規アンロック */}
          {newUnlockNames.length > 0 && (
            <div style={styles.newUnlock}>
              🔓 新しい対戦相手が解放されました！
              <div style={{ marginTop: '8px', fontWeight: 'bold' }}>
                {newUnlockNames.join('、')}
              </div>
            </div>
          )}

          {/* デイリー制限メッセージ */}
          {isWin && !hasReward && (
            <div style={{ textAlign: 'center', color: '#a0a0a0', padding: '16px' }}>
              本日の報酬は既に獲得済みです
            </div>
          )}
        </div>

        {/* フッター */}
        <div style={modalStyles.footer}>
          <div style={styles.buttonGroup}>
            <button
              style={{ ...modalStyles.button, ...modalStyles.buttonPrimary }}
              onClick={onClose}
            >
              マップに戻る
            </button>
            {onRematch && (
              <button
                style={{ ...modalStyles.button, ...modalStyles.buttonSecondary }}
                onClick={onRematch}
              >
                もう一度戦う
              </button>
            )}
            {hasPacks && onOpenPacks && (
              <button
                style={{ ...modalStyles.button, ...modalStyles.buttonSecondary }}
                onClick={onOpenPacks}
              >
                🎴 パックを開く
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BattleResultModal;
